export const Textarea = {
    baseStyle() {
        return {};
    },
    variants: {
        bridge: () => {
            return {
                borderWidth: '1px',
                borderColor: 'brand.gray-scale-border-10',
                backgroundColor: 'brand.background-dark-blue',
                rounded: '8px',
                _placeholder: {
                    color: 'brand.gray-scale-light-grey',
                },
            };
        },
    },
    sizes: {},
    defaultProps: {},
};
